<div class="contact-area ptb-100">
    <div class="container">
        <div class="section-title">
            <!-- <span>Have Questions?</span> -->
            <h2>Shape the Next Roundtable- What Would You Like to Discuss?
            </h2>
            <!-- <p>We would love to hear from you! Reach out to us for inquiries, partnership opportunities, or any
                questions you may have about the RoundtableCxO.</p> -->
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="contact-form">
                    <form id="contactForm" [formGroup]="userForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="name" id="name" class="form-control" placeholder=""
                                        formControlName="name" autocomplete="off">
                                    <label for="fname" class="form-label">Name <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['name'].valid && (userForm.controls['name'].touched || submitAttempt)">
                                        Name is required.
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="email" name="email" id="email" class="form-control" autocomplete="off"
                                        placeholder="" formControlName="email">
                                    <label for="fname" class="form-label">Email <sup>*</sup> </label>

                                    <div *ngIf="(userForm.controls['email'].touched || submitAttempt)&& userForm.controls['email'].invalid"
                                        class="text-danger">
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['required']">
                                            Email is required.
                                        </div>
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['pattern']">
                                            Please enter valid email address
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder="" formControlName="company">
                                    <label for="fname" class="form-label">Company <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['company'].valid && (userForm.controls['company'].touched || submitAttempt)">
                                        Company is required
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder="" formControlName="title">
                                    <label for="fname" class="form-label">Title <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['title'].valid && (userForm.controls['title'].touched || submitAttempt)">
                                        Title is required
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder="" formControlName="topic">
                                    <label for="fname" class="form-label">Requested Topic <sup>*</sup></label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['topic'].valid && (userForm.controls['topic'].touched || submitAttempt)">
                                        Topic is required
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder=" " formControlName="city">
                                    <label for="fname" class="form-label">Your City <sup>*</sup></label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['city'].valid && (userForm.controls['city'].touched || submitAttempt)">
                                        City is required
                                    </div>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label float-label-state"
                                    [class.option-selected]="userForm.controls['state'].value">
                                    <select class="form-control blkcolor form-select state-form-select" id="states"
                                        formControlName="state">
                                        <option value="" disabled>State <sup>*</sup></option>
                                        <option *ngFor="let state of states" [value]="state.name">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                    <small class="text-danger"
                                        *ngIf="userForm.controls['state'].invalid && (userForm.controls['state'].touched || submitAttempt)">
                                        State is required
                                    </small>
                                </div>
                            </div>





                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" minlength="5" maxlength="5" id="msg_subject"
                                        class="form-control" autocomplete="off" placeholder=" " formControlName="zip">
                                    <label for="fname" class="form-label">Zip </label>

                                    <small class="text-danger error-block"
                                        *ngIf="(userForm.controls['zip'].touched || submitAttempt) && userForm.controls['zip'].errors?.['minlength']">Please
                                        enter valid zipcode</small>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn" (click)="saveForm()"> Submit
                                    <span></span></button>
                                <div id="msgSubmit" class="h3 text-center hidden"></div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="loader" *ngIf="loader">
    <div id="loading"></div>
</div>